import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    Modal,
    ModalBody,
    Button,
    Card,
    CardBody,
    CardFooter,
} from "reactstrap";
import AsyncSelect from 'react-select/async';
import EmailService from '../../../../services/email.service';
import { debounce } from 'lodash';
import { HeaderFooter } from "../../../Masters/Email/data";
import EmailHeader from '../../../Masters/Email/components/Header';
import EmailFooter from '../../../Masters/Email/components/Footer';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";


export const MyOption = (props: any) => {
    const { innerProps, innerRef } = props
        return (
            <div className="d-flex p-1" ref={innerRef} {...innerProps}>
                <div className="flex-grow-1 chat-user-box">
                    <p className="user-title m-0">{props?.data?.label}</p>
                </div>
                <div><span className="badge bg-primary ms-2 align-bottom">{props?.data?.language}</span></div>
            </div>
        );
};


const TemplateListModel = (props: any) => {

    const { filters, selectTemplate } = props;
    const [template, setTemplate] = useState<any>('');
    const { t } = useTranslation();
    const toastId = useRef(null) as any;
    const loadOptions = async (keyword: string) => {
        const filter = {
            search: keyword,
            extra: filters,

        };
        const user_template = await EmailService.searchTemplate(filter) as any;
        
        if(user_template?.data?.status==='error'){
            toastId.current = toast(user_template?.data?.message || 'Error', {
                type: toast.TYPE.WARNING,
                isLoading: false,
                autoClose: 4000,
            });
            return [];
        }
        if(user_template?.data?.status==='success'){
            return user_template?.data?.data || [];
        }
        
    };
    const loadSuggestedOptions = useCallback(
        debounce((inputValue, callback) => {
            loadOptions(inputValue).then(options => callback(options))
        }, 500), []);

    const loadAttachmentOptions = async (keyword: string) => {
        const filter = {
            search: keyword,
            extra: filters,
        };
        const attachments = await EmailService.searchAttachment(filter) as any;
        return attachments?.data?.data || [];
    };

    const loadAttachmentOption = useCallback(
        debounce((inputValue, callback) => {
            loadAttachmentOptions(inputValue).then(options => callback(options))
        }, 500), []);

    const handleOnChange = (value: any) => {
        setTemplate(value.value);
    };

    const handleSelectTemplate = () => {
        selectTemplate(template);
        props.onCloseClick();
    }
 

    return (
        <Modal
            size="lg"
            isOpen={props.show}
            toggle={props.onCloseClick}
            backdrop="static"
            keyboard={false}
            autoFocus={false}>
            <div className="modal-header">
                <h5 className="modal-title">{props.title}</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={props.onCloseClick}
                    aria-label="Close"></button>
            </div>
            <ModalBody>
                <Card>
                    <CardBody>
                        <div className="mb-3">
                            <AsyncSelect
                                cacheOptions
                                loadOptions={loadSuggestedOptions}
                                defaultOptions
                                placeholder={t("Search")}
                                isClearable={false}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                    Option: MyOption,
                                }}
                                onChange={handleOnChange}
                            />
                            {template && <div className="row mt-3 mb-3">
                                <div className="col-12">
                                    <EmailHeader header={HeaderFooter[0].header} />
                                    <div style={{ 'padding': '15px' }}>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: template }}
                                        />
                                        {/* <FooterButton title={item.button} /> */}
                                    </div>
                                    <EmailFooter footer={HeaderFooter[0].footer} />
                                </div>

                            </div>}
                        </div>
                    </CardBody>
                    <CardFooter className="d-sm-flex flex-wrap bg-transparent border-top">
                        <div className="ms-auto d-flex gap-2 justify-content-end">
                            <Button
                                color="primary"
                                className="btn-block"
                                type="button"
                                onClick={() => handleSelectTemplate()}
                            >
                                <span>{t("Apply")}</span>
                            </Button>
                        </div>
                    </CardFooter>
                </Card>
            </ModalBody>
        </Modal>
    )
}

export default TemplateListModel;